import { render } from "./ElementThumbnail.vue?vue&type=template&id=52d9ced5&scoped=true&ts=true"
import script from "./ElementThumbnail.vue?vue&type=script&lang=ts"
export * from "./ElementThumbnail.vue?vue&type=script&lang=ts"

import "./ElementThumbnail.vue?vue&type=style&index=0&id=52d9ced5&scoped=true&lang=css"

import exportComponent from "/builds/arkindex/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52d9ced5"]])

export default __exports__